import { getAccessToken, getApiBaseUrl, refreshAccessToken, clearTokens } from "./auth";

async function fetchConfig(token: string): Promise<Record<string, unknown> | null> {
  const response = await fetch(`${getApiBaseUrl()}/api/config/`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  if (response.ok) {
    return response.json();
  }

  return null;
}

function lookupHotkey(lookup: string): Record<string, unknown> | null {
  const customHotkeys = (window.APP_SETTINGS?.user as Record<string, unknown>)?.customHotkeys as
    | Record<string, Record<string, unknown>>
    | undefined;

  if (customHotkeys && lookup in customHotkeys) {
    const hotkeyValue = customHotkeys[lookup];
    if (hotkeyValue && hotkeyValue.active === false) {
      return { ...hotkeyValue, key: null };
    }
    return hotkeyValue;
  }

  const defaultHotkeys = (window as any).DEFAULT_HOTKEYS as Record<string, Record<string, unknown>> | undefined;
  if (defaultHotkeys && lookup in defaultHotkeys) {
    return defaultHotkeys[lookup];
  }

  return null;
}

export async function bootstrap(): Promise<boolean> {
  let token = getAccessToken();

  if (!token) {
    return false;
  }

  let config = await fetchConfig(token);

  if (!config) {
    // Try refreshing the token
    token = await refreshAccessToken();
    if (!token) {
      clearTokens();
      return false;
    }
    config = await fetchConfig(token);
    if (!config) {
      clearTokens();
      return false;
    }
  }

  // Attach lookupHotkey function (previously injected by Django template)
  config.lookupHotkey = lookupHotkey;

  window.APP_SETTINGS = config;
  return true;
}
